export enum EDaysOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6
}

// Mapeamento para exibição em português
export const EDaysOfWeekDisplay: Record<EDaysOfWeek, string> = {
    [EDaysOfWeek.Sunday]: "Domingo",
    [EDaysOfWeek.Monday]: "Segunda-feira",
    [EDaysOfWeek.Tuesday]: "Terça-feira",
    [EDaysOfWeek.Wednesday]: "Quarta-feira",
    [EDaysOfWeek.Thursday]: "Quinta-feira",
    [EDaysOfWeek.Friday]: "Sexta-feira",
    [EDaysOfWeek.Saturday]: "Sábado"
};

// Mapeamento reverso de português para enum
export const EDaysOfWeekFromDisplay: Record<string, EDaysOfWeek> = {
    "Domingo": EDaysOfWeek.Sunday,
    "Segunda-feira": EDaysOfWeek.Monday,
    "Terça-feira": EDaysOfWeek.Tuesday,
    "Quarta-feira": EDaysOfWeek.Wednesday,
    "Quinta-feira": EDaysOfWeek.Thursday,
    "Sexta-feira": EDaysOfWeek.Friday,
    "Sábado": EDaysOfWeek.Saturday
};
